import { render, staticRenderFns } from "./IconPrinciple.vue?vue&type=template&id=2632e974"
import script from "./IconPrinciple.vue?vue&type=script&lang=js"
export * from "./IconPrinciple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports